//import SmartBanner from 'smart-app-banner';
import { __ } from "lib/Utilities";
import 'smart-app-banner/dist/smart-app-banner.css';

const SmartBanner = function () {
	this.data = {
        ios: {
            id: '522452356',
            storeUrl: 'https://apps.apple.com/ca/app/venngo/id522452356?mt=8',
            button: 'OPEN',
            icon: 'https://d7gj223x7eok9.cloudfront.net/assets/images/svg/iconVenngoHome.svg'
        },
        android: {
            id:  'com.venngo.mobileperks',
            storeUrl: 'https://play.google.com/store/apps/details?id=com.venngo.mobileperks',
            button: 'OPEN',
            icon: 'https://d7gj223x7eok9.cloudfront.net/assets/images/svg/iconVenngoHome.svg'
        },
        appSchema: '',
        os: null,
        isMobile: false
    };

    //check if need to show banner at all
	if( /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i.test(navigator.userAgent) ){
        this.data.os = 'ios';
        //check if safari mobile
        this.data.isMobile = /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i.test(navigator.userAgent) ;
    }

    if( /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i.test(navigator.userAgent) ){
        this.data.os = 'android';
        this.data.isMobile = true;
    }

    if( !this.data.isMobile ){
        return;
    }

    //get appschema 
    this.getSchema();

	// for now, we can display original ios smartbanner, maybe change later
	if (this.data.os === 'ios' || this.data.appSchema === '') {
		return;
	}

	this.create();
};

SmartBanner.prototype = {
	create() {
        const sb = document.createElement('div');

		sb.className = `smartbanner smartbanner-${this.data.os}`;
		sb.innerText = `<div class="smartbanner-container">
							<a href="javascript:void(0);" class="smartbanner-close" id="smartbanner-close">&times;</a>
							<span class="smartbanner-icon" style="background-image: url(${this.data[this.data.os].icon})"></span>
							<div class="smartbanner-info">
								<div class="smartbanner-title">${__("about.mobile_title")}</div>
								<div>${__("about.mobile_author")}</div>
								<span>${__("about.mobile_offer")}</span>
							</div>
							<a href="javascript:void(0);" class="smartbanner-button" id="smartbanner-button">
								<span class="smartbanner-button-text">${this.data[this.data.os].button}</span>
							</a>
						</div>`;

        document.body.appendChild(sb);
        document.documentElement.className += 'smartbanner-show';

        document.getElementById('smartbanner-button').addEventListener('click', () => {
            this.open();
        });

        document.getElementById('smartbanner-close').addEventListener('click', () => {
            this.close();
        });
    },
    open() {
        const data = this.data;
        let redirectStore;

        function preventRedirect() {
            clearTimeout(redirectStore);
            redirectStore = null;
            window.removeEventListener('blur', preventRedirect);
        }

        window.location.href = data.appSchema;

        redirectStore = setTimeout(() => {
            window.location.href = data[data.os].storeUrl;
        }, 500);

        window.addEventListener('blur', preventRedirect);

        document.documentElement.classList.remove('smartbanner-show');
    },
    close() {
        document.documentElement.classList.remove('smartbanner-show');
    },
    getSchema() {
        const meta = document.querySelector("[name~=mobile-app-schema][content]");

        if( meta ){
            this.data.appSchema = meta.getAttribute("content");
        }
    }
}

new SmartBanner();